import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import EditableTimeInput from '@/shared/components/editable/EditableTimeInput';

const HoursPerEmployeeReportDetailRow = ({
  userId,
  type,
  values,
  total,
  label,
  columns,
  toggleResources,
  showResources,
  onUpdateHomeWorkingHours,
}) => {
  const toggleFunction = toggleResources;

  return (
    <tr key={`${userId}-${type}`} className={classnames('details', `details-${type}`)}>
      <td onClick={toggleFunction}>
        {toggleResources ? (
          <span className="caret-button">
            <i
              className={classnames('fa pointer', showResources ? 'fa-caret-up' : 'fa-caret-down')}
            />
          </span>
        ) : null}
        {label}
      </td>
      {columns.map(col => {
        const value = values[col.groupNr];
        return (
          <td
            key={col.groupNr}
            className={classnames('text-right hours', {
              'text-muted': !value,
            })}
          >
            <EditableTimeInput
              value={value}
              displayValue={!value && value !== 0 ? null : value.minuteToTime()}
              onChange={x => onUpdateHomeWorkingHours(userId, col.startDate, x)}
              allowNull
              padHours={false}
            />
          </td>
        );
      })}
      <td
        className={classnames('text-right hours', {
          'text-muted': !total,
        })}
      >
        {total.minuteToTime()}
      </td>
    </tr>
  );
};
HoursPerEmployeeReportDetailRow.propTypes = {
  onUpdateHomeWorkingHours: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  type: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  values: PropTypes.shape({}),
  label: PropTypes.node,
  columns: PropTypes.arrayOf(PropTypes.shape({})),
  toggleResources: PropTypes.func,
  showResources: PropTypes.bool,
};
HoursPerEmployeeReportDetailRow.defaultProps = {
  values: {},
  label: null,
  columns: [],
  toggleResources: undefined,
  showResources: false,
};

export default HoursPerEmployeeReportDetailRow;
